<template>
    <div class="modal flex" :class="className" v-show="show" transition="fade" :style="{zIndex:zIndex}">
        <div class="modal-backdrop in" @click="clickBack"></div>
        <div class="modal-dialog" :style="{width: width}">
            <div class="modal-content">
                <slot name="content">
                    <slot name="header">
                        <div class="modal-header">
                            <button type="button" class="close" @click.stop="close()"></button>
                            <slot name="title">
                                <h4 class="modal-title">{{title}}</h4>
                            </slot>
                        </div>
                    </slot>
                    <div class="modal-body">
                        <slot></slot>
                    </div>
                    <slot name="footer">
                        <div class="modal-footer">
                            <button type="button" class="btn dark btn-outline" @click.stop="close()">关闭</button>
                            <slot name="button"></slot>
                        </div>
                    </slot>
                </slot>
            </div>
        </div>
    </div>
</template>
<style type="text/css">
.modal{
    display: block;
}
.modal.flex{
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -moz-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  -moz-align-items: center;
  align-items: center;
}


</style>
<script type="text/javascript">

import { mapState, mapActions } from 'vuex';

export default {
    props:['show', 'title', 'width', 'hideOnClickOut', 'className'],
    data() {
        return {
            zIndex: 0
        }
    },
    computed: mapState([
        'maxZIndex'
    ]),
    methods: {
        ...mapActions([
            'increaseZIndex'
        ]),
        close(){
            this.show = false;
        },
        clickBack() {
            if(this.hideOnClickOut == 'true') {
                this.show = false;
            }
        }
    },
    watch: {
        'show': function(val, oldVal){
            if(val === true) {
                this.increaseZIndex();
                this.zIndex = this.maxZIndex;
            }
        }
    }
}
</script>
